module.exports = __webpack_public_path__ + "static/media/Zubair_Ali_Resume.fc3fe146.pdf";